









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class TotalWidget extends Vue {
  @Prop() total!: number;
  @Prop() title!: string;

  private formatValue(value: number): string {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    });

    return formatter.format(value);
  }
}
